<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refInventoryGrid'
          :data-source='inventoryReceiptInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :focused-row-key.sync='focusedRowKey'
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @toolbar-preparing='onToolbarPreparing'
          @row-updated='onRowUpdated' @row-updating="onRowUpdating"
          @editor-preparing='onEditorPreparing'
          @cell-prepared='onCellPreparedOutput'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="exportTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="false"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          />
          <DxSelection mode="single"
            show-check-boxes-mode="always"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="처리일"
            data-field="발생일자"
            dataType='date'
            sort-order='asc'
            format='yyyy-MM-dd'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            :min-width="124"
            caption="처리일시"
            data-field="발생일자"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm:ss'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="공정유형"
            data-field="공정유형"
            :visible='true'
          >
            <DxLookup
              :data-source="processingTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="자재유형"
            data-field="자재유형"
            :visible='true'
          >
            <DxLookup
              :data-source="meterialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구분"
            data-field="입출고구분"
            :visible='true'
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="폐기수량"
            data-field="폐기수량"
            dataType='number'
            :visible='true'
            format='#,##0'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="자재 반품수량"
            data-field="반품수량"
            dataType='number'
            :visible='true'
            format='#,##0'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="제품 반송수량"
            data-field="반송수량"
            dataType='number'
            :visible='true'
            format='#,##0'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="제품 재투입수량"
            data-field="재투입수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="판매단가"
            data-field="판매가"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <!-- <DxColumn
            :allowEditing='false'
            caption="반송금액"
            data-field="반송금액"
            :calculate-cell-value="calcAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn> -->
          <DxColumn
            :allowEditing='false'
            caption="구입단가"
            data-field="구입가"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <!-- <DxColumn
            :allowEditing='false'
            caption="구매금액"
            data-field="구매금액"
            :calculate-cell-value="calcAmountCost"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn> -->
          <DxColumn
            :allowEditing='false'
            caption="파레트번호"
            data-field="입고키"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="거래처"
            data-field="거래처명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :visible="false"
            width="90"
            :buttons="editSubButtons"
            type="buttons"
          />
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="폐기수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="반품수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="반송수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="재투입수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="반송금액"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="구매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup, DxSelection,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport, DxEditing } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'

export default {
  name: 'production-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '불량/반송 현황'
        }
      ],
      inventoryReceiptInfo: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      focusedRowKey: null,
      editSubButtons: ['edit', 'delete'],
      isEditable: true,
      processingTypeLookup: null,
      meterialTypeLookup: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxEditing,
    DxRequiredRule,
    DxSelection
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.receiptTypeLookup = ConstDef.BAD_INOUT_CODE
    this.refreshInventoryList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcAmount (row) {
      return row.판매가 * row.반송수량
    },
    calcAmountCost (row) {
      return row.구입가 * row.반품수량
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (e.data.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품반품' }).코드) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
    },
    onClickPrintReceipt (e) {

    },
    onEditorPreparing (e) {
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runDeleteSqlProc('창고수불', [{ seqId: row.data.seqId }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (e) {

    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()

      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], ['자재유형', '품목유형', '품명', '거래처명', '발생일'], [row.data])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      console.log(row)
      if (row.oldData.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품출하' }).코드) {
        if (row.newData.출하차량 !== undefined && row.newData.출하차량.length === 0) {
          this.$snotify.error('납품챠량 번호를 입력하여 주세요')
          row.cancel = true
        }
      }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.thisMonth = args.value
              this.refreshInventoryList()
            }
          }
        }
      )
    },
    refreshInventoryList () {
      if (AppLib.getToday().substring(0, 7) === `${this.thisYear}-${this.thisMonth}`) {
        this.isEditable = true
      } else {
        this.isEditable = false
      }
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-제품출하현황`

      this.isLoading = true
      let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        startDate: `${this.thisYear}-${this.thisMonth}-01 ${this.$store.getters.getSysParamByKey('재고관리기준시간')}`,
        endDate: `${endDate} ${this.$store.getters.getSysParamByKey('재고관리기준시간')}`
      }
      this.$_sp.runNoEncodeFindProc('spFindAllBedReceiptByDateAndGoodsType', param)
        .then((data) => {
          this.isLoading = false
          this.inventoryReceiptInfo = this.$_sp.MakeModel(data)
          console.log(this.inventoryReceiptInfo)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
